import type { SendPushToAllRequest } from '../entities/push_notification.entity'
import type { PushNotificationRepository } from '../repositories/push_notification_repository'

export class SendPushToAllUseCase {
  constructor(private readonly repository: PushNotificationRepository) {}

  execute(request: SendPushToAllRequest): Promise<void> {
    return this.repository.sendToAll(request)
  }
}
